import React, { useState, useEffect } from "react";
import "../styles/autocomplete.css";
import Autocomplete from "../components/AutocompleteForms";
import Modal from "react-modal";
import GeoAdmin from "./Administracion/GeoAdmin";
import Direccion from "./Administracion/Direccion";
const FormularioModulos = (props) => {
  // eslint-disable-next-line
  const formulario = props.formulario;
  // eslint-disable-next-line
  const [update, setUpdate] = useState(false);
  // eslint-disable-next-line
  const setFormulario = props.setFormulario;
  const modulo = props.modulo;
  const customStyles = {
    content: {
      top: "50%",
      left: "50%",
      right: "50%",
      bottom: "auto",
      marginRight: "-50%",
      transform: "translate(-50%, -50%)",
    },
  };

  let closeModal = () => {
    props.setModalIsOpen("");
  };
  let closeModalDir = () => {
    setModalState(false);
    setModalState2(false);
  };

  let crear = (e) => {
    setUpdate(!update);
    props.crear(e);
  };

  const [modalState, setModalState] = useState(false);
  const [modalState2, setModalState2] = useState(false);

  let handleFormularioStage = (e, autocomplete) => {
    const value = e.target.value ? e.target.value : e.currentTarget.innerText;
    const name = e.target.getAttribute("name");

    props.setFormulario({
      ...props.formulario,
      [name]: value,
    });
  };

  // Preselecciona el primer estado de factura del catalogo cuando el catalogo
  // termina de cargar y el formulario todavia no tiene uno elegido. Asi al
  // crear un gasto sin tocar el select, igual se persiste el primer estado.
  useEffect(() => {
    if (
      modulo === "Gastos Normales" &&
      Array.isArray(props.facturaStatusTypes) &&
      props.facturaStatusTypes.length > 0 &&
      props.formulario &&
      props.formulario.factura_status_id == null
    ) {
      props.setFormulario({
        ...props.formulario,
        factura_status_id: props.facturaStatusTypes[0].factura_status_id,
      });
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [props.facturaStatusTypes, modulo]);

  let modalsKrud = (
    <>
      <Modal
        isOpen={modalState}
        contentLabel="Example Modal"
        ariaHideApp={false}
        style={customStyles}
        onRequestClose={closeModal}
      >
        <button
          style={{ position: "absolute", right: "20px", top: "14px" }}
          className=" button  btn-primary"
          onClick={closeModalDir}
        >
          X
        </button>

        <GeoAdmin sideBar={false} userTab={false}>
          {" "}
        </GeoAdmin>
      </Modal>

      <Modal
        isOpen={modalState2}
        contentLabel="Example Modal"
        ariaHideApp={false}
        style={customStyles}
        onRequestClose={closeModal}
      >
        <button
          style={{ position: "absolute", right: "20px", top: "14px" }}
          className=" button  btn-primary"
          onClick={closeModalDir}
        >
          X
        </button>

        <Direccion sideBar={true} userTab={true}>
          {" "}
        </Direccion>
      </Modal>
    </>
  );

  if (modulo === "Etapas") {
    return (
      <>
        <Modal
          isOpen={props.modalIsOpen === "Etapas" ? true : false}
          contentLabel="Example Modal"
          ariaHideApp={false}
          style={customStyles}
          onRequestClose={closeModal}
        >
          <button
            style={{ position: "absolute", right: "20px", top: "14px" }}
            className=" button  btn-primary"
            onClick={closeModal}
          >
            X
          </button>
          <h4>Agregar Etapa</h4>
          <form id={modulo}>
            <div className="col-md-12">
              <div className="col-md-4">
                <h5>Tipo Etapa</h5>
                <select
                  className="form-control"
                  value={props.formulario.stage_type_name || ""}
                  onChange={(e) => {
                    const v = e.target.value;
                    // Al cambiar el tipo, limpiamos la subetapa elegida porque
                    // probablemente sea de un tipo distinto.
                    props.setFormulario({
                      ...props.formulario,
                      stage_type_name: v,
                      stage: "",
                    });
                  }}
                >
                  <option value="">Todos</option>
                  <option value="MACRO">MACRO</option>
                  <option value="ETAPA">ETAPA</option>
                  <option value="SUBETAPA">SUBETAPA</option>
                </select>
              </div>
              <div className="col-md-4">
                <h5>Sub Etapa</h5>

                <Autocomplete
                  personalHandleChange={handleFormularioStage}
                  nameElement={"stage"}
                  formularioBuscado={props.formulario}
                  setformulario={props.setFormulario}
                  key={(props.formulario.stage_type_name || "") + update}
                  required={true}
                  value={props.formulario.stage}
                  suggestions={
                    props.formulario.stage_type_name
                      ? (props.listax3 || []).filter(
                          (x) =>
                            x.stage_type_name ===
                            props.formulario.stage_type_name
                        )
                      : props.listax3
                  }
                />
              </div>
              <div className="col-md-4">
                <h5>Comentario</h5>
                <input
                  onChange={handleFormularioStage}
                  name="comment"
                  required
                  className="form-control"
                ></input>
              </div>
            </div>
            <div className="col-md-12">
              <div className="col-md-4">
                <h5>Fecha inicio</h5>
                <input
                  type={"date"}
                  onChange={handleFormularioStage}
                  name="startdate"
                  required
                  className="form-control"
                  value={props.formulario.startdate || ""}
                ></input>
              </div>
            </div>
            <div className="col-md-12">
              <div className="col-md-4">
                <h5>Persona asociada</h5>

                <Autocomplete
                  personalHandleChange={handleFormularioStage}
                  nameElement={"associated_person"}
                  formularioBuscado={props.formulario}
                  setformulario={props.setFormulario}
                  key={update}
                  required={true}
                  value={props.formulario.associated_person}
                  suggestions={props.listax2}
                />
              </div>
              <div className="col-md-4">
                <br />
                <button
                  type="button"
                  onClick={(e) => {
                    crear(e);
                  }}
                  value="Submit"
                  style={{ margin: "14px 0px" }}
                  id="btnBuscar"
                  className="form-control button brEdit btn-primary"
                >
                  Agregar
                </button>
              </div>
            </div>
          </form>
        </Modal>
      </>
    );
  }
  if (modulo === "Estados") {
    return (
      <>
        <Modal
          isOpen={props.modalIsOpen === "Estados" ? true : false}
          contentLabel="Example Modal"
          ariaHideApp={false}
          style={customStyles}
          onRequestClose={closeModal}
        >
          <button
            style={{ position: "absolute", right: "20px", top: "14px" }}
            className=" button  btn-primary"
            onClick={closeModal}
          >
            X
          </button>

          <h4>Agregar Estados</h4>
          <form id={modulo}>
            <div className="col-md-12">
              <div className="col-md-4">
                <h5>Estados</h5>

                <Autocomplete
                  personalHandleChange={handleFormularioStage}
                  nameElement={"state"}
                  formularioBuscado={props.formulario}
                  setformulario={props.setFormulario}
                  key={update}
                  required={true}
                  value={props.formulario.state}
                  suggestions={props.listax}
                />
              </div>

              <div className="col-md-4">
                <h5>Fecha Inicio</h5>
                <input
                  type={"date"}
                  onChange={handleFormularioStage}
                  name="startdate"
                  required
                  className="form-control"
                  value={props.formulario.startdate || ""}
                ></input>
              </div>

              <div className="col-md-4">
                <h5>Comentario</h5>
                <input
                  type={"text"}
                  onChange={handleFormularioStage}
                  name="comment"
                  className="form-control"
                ></input>
              </div>
            </div>

            <div className="col-md-12">
              <div className="col-md-4">
                <br />
                <button
                  type="button"
                  onClick={(e) => {
                    crear(e);
                  }}
                  value="Submit"
                  style={{ margin: "14px 0px" }}
                  id="btnBuscar"
                  className="form-control button brEdit btn-primary"
                >
                  Agregar
                </button>
              </div>
            </div>
          </form>
        </Modal>
      </>
    );
  }

  if (modulo === "Pagos") {
    return (
      <>
        <Modal
          isOpen={props.modalIsOpen === "Pagos" ? true : false}
          contentLabel="Example Modal"
          ariaHideApp={false}
          style={customStyles}
          onRequestClose={closeModal}
        >
          <button
            style={{ position: "absolute", right: "20px", top: "14px" }}
            className=" button  btn-primary"
            onClick={closeModal}
          >
            X
          </button>
          <h4>Agregar Pagos</h4>
          <form id={modulo}>
            <div className="col-md-4">
              <h5>Monto</h5>
              <input
                onChange={handleFormularioStage}
                type="number"
                name="amount"
                required
                className="form-control"
              ></input>
            </div>

            <div className="col-md-4">
              <h5>Fecha</h5>
              <input
                type={"date"}
                onChange={handleFormularioStage}
                name="date"
                required
                className="form-control"
              ></input>
            </div>

            <div className="col-md-4">
              <h5>Descripción</h5>
              <input
                onChange={handleFormularioStage}
                name="description"
                required
                className="form-control"
              ></input>
            </div>

            <div className="col-md-4">
              <h5>Comprobante</h5>
              <input
                onChange={handleFormularioStage}
                name="client_payment_id"
                required
                className="form-control"
              ></input>
            </div>

            <div className="col-md-4">
              <h5>Moneda</h5>
              <Autocomplete
                value={props.formulario.currency}
                nameElement={"currency"}
                formularioBuscado={props.formulario}
                setformulario={props.setFormulario}
                key={update}
                required={true}
                personalHandleChange={handleFormularioStage}
                suggestions={props.listax}
              ></Autocomplete>
            </div>

            <div className="col-md-4">
              <br />
              <button
                type="button"
                onClick={(e) => {
                  crear(e);
                }}
                value="Submit"
                style={{ margin: "14px 0px" }}
                id="btnBuscar"
                className="form-control button brEdit btn-primary"
              >
                Agregar
              </button>
            </div>
          </form>
        </Modal>
      </>
    );
  }
  if (modulo === "Gastos Normales") {
    return (
      <>
        <Modal
          isOpen={props.modalIsOpen === "Gastos Normales" ? true : false}
          contentLabel="Example Modal"
          ariaHideApp={false}
          style={customStyles}
          onRequestClose={closeModal}
        >
          <button
            style={{ position: "absolute", right: "20px", top: "14px" }}
            className=" button  btn-primary"
            onClick={closeModal}
          >
            X
          </button>

          <h4>Agregar</h4>
          <form id={modulo}>
            <div className="col-md-4">
              <h5>Descripcion</h5>
              <input
                onChange={handleFormularioStage}
                name="description"
                required
                className="form-control"
              ></input>
            </div>

            <div className="col-md-4">
              <h5>Fecha</h5>
              <input
                type={"date"}
                onChange={handleFormularioStage}
                name="date"
                required
                className="form-control"
              ></input>
            </div>

            <div className="col-md-4">
              <h5>Monto</h5>
              <input
                onChange={handleFormularioStage}
                type="number"
                name="amount"
                required
                className="form-control"
              ></input>
            </div>

            <div className="col-md-4">
              <h5>Concepto Deuda</h5>
              <Autocomplete
                value={props.formulario.concept}
                nameElement={"concept"}
                formularioBuscado={props.formulario}
                setformulario={props.setFormulario}
                key={update}
                required={true}
                personalHandleChange={handleFormularioStage}
                suggestions={props.listax}
              ></Autocomplete>
            </div>
            <div className="col-md-4">
              <h5>Moneda</h5>
              <Autocomplete
                value={props.formulario.currency}
                nameElement={"currency"}
                formularioBuscado={props.formulario}
                setformulario={props.setFormulario}
                key={update}
                required={true}
                personalHandleChange={handleFormularioStage}
                suggestions={props.listax2}
              ></Autocomplete>
            </div>

            <div className="col-md-4">
              <h5>Persona Asociada</h5>
              <Autocomplete
                value={props.formulario.associated_person}
                nameElement={"associated_person"}
                formularioBuscado={props.formulario}
                setformulario={props.setFormulario}
                key={update}
                required={true}
                personalHandleChange={handleFormularioStage}
                suggestions={props.listax3}
              ></Autocomplete>
            </div>

            <div className="col-md-4">
              <h5>Factura</h5>
              <input
                onChange={handleFormularioStage}
                name="factura"
                className="form-control"
              ></input>
            </div>

            <div className="col-md-4">
              <h5>BH Receptor</h5>
              <input
                onChange={handleFormularioStage}
                type="number"
                name="bh_receptor"
                className="form-control"
              ></input>
            </div>

            <div className="col-md-4">
              <h5>Estado Factura</h5>
              <select
                value={props.formulario.factura_status_id ?? ""}
                onChange={(e) => {
                  const v = e.target.value;
                  const parsed = v === "" ? null : parseInt(v, 10);
                  props.setFormulario({
                    ...props.formulario,
                    factura_status_id: parsed,
                  });
                }}
                name="factura_status_id"
                className="form-control"
              >
                {(props.facturaStatusTypes || []).map((st) => (
                  <option
                    key={st.factura_status_id}
                    value={st.factura_status_id}
                  >
                    {st.name}
                  </option>
                ))}
              </select>
            </div>

            <div className="col-md-4">
              <br />
              <button
                type="button"
                onClick={(e) => {
                  crear(e);
                }}
                value="Submit"
                style={{ margin: "14px 0px" }}
                id="btnBuscar"
                className="form-control button brEdit btn-primary"
              >
                Agregar
              </button>
            </div>
          </form>
        </Modal>
      </>
    );
  }
  if (modulo === "Bienes") {
    return (
      <>
        <Modal
          isOpen={props.modalIsOpen === "Bienes" ? true : false}
          contentLabel="Example Modal"
          ariaHideApp={false}
          style={customStyles}
          onRequestClose={closeModal}
        >
          <button
            style={{ position: "absolute", right: "20px", top: "14px" }}
            className=" button  btn-primary"
            onClick={closeModal}
          >
            X
          </button>

          <h4> Agregar Bienes</h4>
          <form id={modulo}>
            <div className="col-md-4">
              <h5>Tipo</h5>
              <Autocomplete
                value={props.formulario.typeAsset}
                nameElement={"typeAsset"}
                formularioBuscado={props.formulario}
                setformulario={props.setFormulario}
                key={update}
                required={true}
                personalHandleChange={handleFormularioStage}
                suggestions={props.listax2}
              ></Autocomplete>
            </div>
            <div className="col-md-4">
              <h5>Moneda</h5>
              <Autocomplete
                value={props.formulario.currencyId}
                nameElement={"currencyId"}
                formularioBuscado={props.formulario}
                setformulario={props.setFormulario}
                key={update}
                required={true}
                personalHandleChange={handleFormularioStage}
                suggestions={props.listax4}
              ></Autocomplete>
            </div>
            <div className="col-md-4">
              <h5>Ubicación</h5>
              <Autocomplete
                value={props.formulario.location}
                nameElement={"location"}
                formularioBuscado={props.formulario}
                setformulario={props.setFormulario}
                key={update}
                required={true}
                personalHandleChange={handleFormularioStage}
                suggestions={props.listax5}
              ></Autocomplete>
            </div>

            <div className="col-md-4">
              <h5>Origen de datos</h5>
              <Autocomplete
                value={props.formulario.dataorigin}
                nameElement={"dataorigin"}
                formularioBuscado={props.formulario}
                setformulario={props.setFormulario}
                key={update}
                required={true}
                personalHandleChange={handleFormularioStage}
                suggestions={props.listax6}
              ></Autocomplete>
            </div>

            <div className="col-md-4">
              <h5>Valor</h5>
              <input
                onChange={handleFormularioStage}
                type={"number"}
                name="value"
                required
                className="form-control"
              ></input>
            </div>

            <div className="col-md-4">
              <h5>Descripción</h5>
              <input
                onChange={handleFormularioStage}
                name="description"
                required
                className="form-control"
              ></input>
            </div>

            <div className="col-md-4">
              <h5>Activo</h5>
              <input
                onChange={handleFormularioStage}
                type="checkbox"
                name="isActive"
                className="form-control c1"
              ></input>
            </div>

            <div className="col-md-4">
              <h5>Propietario</h5>

              <Autocomplete
                value={props.formulario.owner}
                nameElement={"owner"}
                formularioBuscado={props.formulario}
                setformulario={props.setFormulario}
                key={update}
                required={true}
                personalHandleChange={handleFormularioStage}
                suggestions={props.listax7}
              ></Autocomplete>
            </div>

            <div className="col-md-4">
              <h5>Arrendatario</h5>

              <Autocomplete
                value={props.formulario.tenant}
                nameElement={"tenant"}
                formularioBuscado={props.formulario}
                setformulario={props.setFormulario}
                key={update}
                personalHandleChange={handleFormularioStage}
                suggestions={props.listax7}
              ></Autocomplete>
            </div>

            <div className="col-md-4">
              <h5>Puntaje</h5>
              <input
                onChange={handleFormularioStage}
                type="number"
                name="score"
                required
                className="form-control"
              ></input>
            </div>

            <div className="col-md-4">
              <h5>Fecha información</h5>
              <input
                type={"date"}
                onChange={handleFormularioStage}
                name="infodate"
                required
                className="form-control"
              ></input>
            </div>

            <div className="col-md-12">
              <br />
            </div>

            <div className="col-md-4">
              <br />
              <button
                type="button"
                onClick={(e) => {
                  const notRequiredkeys = ["tenant"];
                  for (const key in props.formulario) {
                    if (
                      !props.formulario[key] &&
                      !notRequiredkeys.includes(key)
                    ) {
                      alert("Debe completar los campos obligatorios");
                      return;
                    }
                  }
                  crear(e);
                }}
                value="Submit"
                style={{ margin: "14px 0px" }}
                id="btnBuscar"
                className="form-control button brEdit btn-primary"
              >
                Agregar
              </button>
            </div>
          </form>

          <div className="col-md-4">
            <br />
            <button
              style={{ margin: "14px 0px" }}
              onClick={() => {
                setModalState(true);
              }}
              id="btnBuscar"
              className="form-control button brEdit btn-secundary"
            >
              Crear comuna
            </button>
          </div>

          <div className="col-md-4">
            <br />
            <button
              style={{ margin: "14px 0px" }}
              onClick={() => {
                setModalState2(true);
              }}
              id="btnBuscar"
              className="form-control button brEdit btn-secundary"
            >
              Crear nueva dirección
            </button>
          </div>

          {modalsKrud}
        </Modal>
      </>
    );
  }
  if (modulo === "Contactos") {
    return (
      <>
        <Modal
          isOpen={props.modalIsOpen === "Contactos" ? true : false}
          contentLabel="Example Modal"
          ariaHideApp={false}
          style={customStyles}
          onRequestClose={closeModal}
        >
          <button
            style={{ position: "absolute", right: "20px", top: "14px" }}
            className=" button  btn-primary"
            onClick={closeModal}
          >
            X
          </button>

          <h4>Agregar Contacto</h4>
          <form id={modulo}>
            <div className="col-md-4">
              <h5>Valor</h5>
              <input
                onChange={handleFormularioStage}
                type="number"
                name="value"
                required
                className="form-control"
              ></input>
            </div>

            <div className="col-md-4">
              <h5>Fecha Información</h5>
              <input
                type={"date"}
                onChange={handleFormularioStage}
                name="infodate"
                required
                className="form-control"
              ></input>
            </div>

            <div className="col-md-4">
              <h5>Puntos</h5>
              <input
                onChange={handleFormularioStage}
                type="number"
                name="score"
                required
                className="form-control"
              ></input>
            </div>

            <div className="col-md-4">
              <h5>Activo</h5>
              <input
                onChange={handleFormularioStage}
                type="checkbox"
                name="is_active"
                className="form-control c1"
              ></input>
            </div>

            <div className="col-md-4">
              <h5>Contacto</h5>
              <input
                onChange={handleFormularioStage}
                name="additional_info"
                required
                className="form-control"
              ></input>
            </div>

            <div className="col-md-4">
              <h5>Origen Datos</h5>
              <Autocomplete
                value={props.formulario.dataorigin}
                nameElement={"dataorigin"}
                formularioBuscado={props.formulario}
                setformulario={props.setFormulario}
                key={update}
                required={true}
                personalHandleChange={handleFormularioStage}
                suggestions={props.listax}
              ></Autocomplete>
            </div>

            <div className="col-md-4">
              <h5>Clase de contacto</h5>
              <Autocomplete
                value={props.formulario.contactclass}
                nameElement={"contactclass"}
                formularioBuscado={props.formulario}
                setformulario={props.setFormulario}
                key={update}
                required={true}
                personalHandleChange={handleFormularioStage}
                suggestions={props.listax3}
              ></Autocomplete>
            </div>

            <div className="col-md-4">
              <h5>Tipo Contacto</h5>
              <Autocomplete
                value={props.formulario.contacttype}
                nameElement={"contacttype"}
                formularioBuscado={props.formulario}
                setformulario={props.setFormulario}
                key={update}
                required={true}
                personalHandleChange={handleFormularioStage}
                suggestions={props.listax2}
              ></Autocomplete>
            </div>

            <div className="col-md-4">
              <br />
              <button
                type="button"
                onClick={(e) => {
                  crear(e);
                }}
                value="Submit"
                style={{ margin: "14px 0px" }}
                id="btnBuscar"
                className="form-control button brEdit btn-primary"
              >
                Agregar
              </button>
            </div>
          </form>
        </Modal>
      </>
    );
  }

  if (modulo === "Historial") {
    return (
      <>
        <Modal
          isOpen={props.modalIsOpen === "Historial" ? true : false}
          contentLabel="Example Modal"
          ariaHideApp={false}
          style={customStyles}
          onRequestClose={closeModal}
        >
          <button
            style={{ position: "absolute", right: "20px", top: "14px" }}
            className=" button  btn-primary"
            onClick={closeModal}
          >
            X
          </button>

          <h4>Agregar Historial</h4>
          <form id={modulo}>
            <div className="col-md-4">
              <h5>Tipo</h5>
              <Autocomplete
                value={props.formulario.type}
                nameElement={"type"}
                formularioBuscado={props.formulario}
                setformulario={props.setFormulario}
                key={update}
                required={true}
                personalHandleChange={handleFormularioStage}
                suggestions={props.listax}
              ></Autocomplete>
            </div>

            <div className="col-md-4">
              <h5>Resultado</h5>
              <Autocomplete
                value={props.formulario.result}
                nameElement={"result"}
                formularioBuscado={props.formulario}
                setformulario={props.setFormulario}
                key={update}
                required={true}
                personalHandleChange={handleFormularioStage}
                suggestions={props.listax2}
              ></Autocomplete>
            </div>

            <div className="col-md-4">
              <h5>Detalles</h5>
              <input
                onChange={handleFormularioStage}
                name="details"
                required
                className="form-control"
              ></input>
            </div>

            <div className="col-md-4">
              <h5>Fecha</h5>
              <input
                onChange={handleFormularioStage}
                type="date"
                name="date"
                required
                className="form-control"
              ></input>
            </div>

            <div className="col-md-4">
              <br />
              <button
                type="button"
                onClick={(e) => {
                  crear(e);
                }}
                value="Submit"
                style={{ margin: "14px 0px" }}
                id="btnBuscar"
                className="form-control button brEdit btn-primary"
              >
                Agregar
              </button>
            </div>
          </form>
        </Modal>
      </>
    );
  }
  if (modulo === "Direcciones") {
    return (
      <>
        <Modal
          isOpen={props.modalIsOpen === "Direcciones" ? true : false}
          contentLabel="Example Modal"
          ariaHideApp={false}
          style={customStyles}
          onRequestClose={closeModal}
        >
          <button
            style={{ position: "absolute", right: "20px", top: "14px" }}
            className=" button  btn-primary"
            onClick={closeModal}
          >
            X
          </button>
          <h4>Agregar Direcciones</h4>
          <form id={modulo}>
            <div className="col-md-4">
              <h5>Tipo direccion</h5>
              <Autocomplete
                value={props.formulario.address_type}
                nameElement={"address_type"}
                formularioBuscado={props.formulario}
                setformulario={props.setFormulario}
                key={update}
                required={true}
                personalHandleChange={handleFormularioStage}
                suggestions={props.listax}
              ></Autocomplete>
            </div>
            <div className="col-md-4">
              <h5>Origen de datos</h5>
              <Autocomplete
                value={props.formulario.dataorigin}
                nameElement={"dataorigin"}
                formularioBuscado={props.formulario}
                setformulario={props.setFormulario}
                key={update}
                required={true}
                personalHandleChange={handleFormularioStage}
                suggestions={props.listax3}
              ></Autocomplete>
            </div>

            <div className="col-md-4">
              <h5>Unidad direccion</h5>
              <Autocomplete
                value={props.formulario.address_unit}
                nameElement={"address_unit"}
                formularioBuscado={props.formulario}
                setformulario={props.setFormulario}
                key={update}
                required={true}
                personalHandleChange={handleFormularioStage}
                suggestions={props.listax2}
              ></Autocomplete>
            </div>

            <div className="col-md-4">
              <h5>Direccion</h5>
              <Autocomplete
                value={props.formulario.address}
                nameElement={"address"}
                formularioBuscado={props.formulario}
                setformulario={props.setFormulario}
                key={update}
                required={true}
                personalHandleChange={handleFormularioStage}
                suggestions={props.listax4}
              ></Autocomplete>
            </div>
            <div className="col-md-4">
              <h5>Puntaje</h5>
              <input
                onChange={handleFormularioStage}
                defaultChecked={props.formulario.score}
                type="number"
                name="score"
                className="form-control c1"
              ></input>
            </div>

            <div className="col-md-4">
              <h5>Fecha Informacion</h5>
              <input
                type={"date"}
                onChange={handleFormularioStage}
                name="infodate"
                required
                className="form-control"
              ></input>
            </div>

            <div className="col-md-4">
              <h5>Activo</h5>
              <input
                onChange={handleFormularioStage}
                defaultChecked={props.formulario.is_active}
                type="checkbox"
                name="is_active"
                className="form-control c1"
              ></input>
            </div>

            <div className="col-md-4">
              <h5>Bloqueo</h5>
              <input
                onChange={handleFormularioStage}
                defaultChecked={props.formulario.is_blocked}
                type="checkbox"
                name="is_blocked"
                className="form-control c1"
              ></input>
            </div>

            <div className="col-md-12">
              <br></br>
            </div>
            <div className="col-md-4">
              <br />
              <button
                type="button"
                onClick={(e) => {
                  crear(e);
                }}
                value="Submit"
                style={{ margin: "14px 0px" }}
                id="btnBuscar"
                className="form-control button brEdit btn-primary"
              >
                Asociar dirección
              </button>
            </div>
          </form>

          <div className="col-md-4">
            <br />
            <button
              style={{ margin: "14px 0px" }}
              onClick={() => {
                setModalState(true);
              }}
              id="btnBuscar"
              className="form-control button brEdit btn-secundary"
            >
              Crear comuna
            </button>
          </div>

          <div className="col-md-4">
            <br />
            <button
              style={{ margin: "14px 0px" }}
              onClick={() => {
                setModalState2(true);
              }}
              id="btnBuscar"
              className="form-control button brEdit btn-secundary"
            >
              Crear nueva dirección
            </button>
          </div>

          {modalsKrud}
        </Modal>
      </>
    );
  }
  if (modulo === "Títulos") {
    return (
      <>
        <Modal
          isOpen={props.modalIsOpen === "Títulos" ? true : false}
          contentLabel="Example Modal"
          ariaHideApp={false}
          style={customStyles}
          onRequestClose={closeModal}
        >
          <button
            style={{ position: "absolute", right: "20px", top: "14px" }}
            className=" button  btn-primary"
            onClick={closeModal}
          >
            X
          </button>
          <h4>Agregar Títulos</h4>
          <form id={modulo}>
            <div className="col-md-4">
              <h5>Tipo Titulo</h5>
              <Autocomplete
                value={props.formulario.type}
                nameElement={"type"}
                formularioBuscado={props.formulario}
                setformulario={props.setFormulario}
                key={update}
                required={true}
                personalHandleChange={handleFormularioStage}
                suggestions={props.listax}
              ></Autocomplete>
            </div>

            <div className="col-md-4">
              <h5>Deuda</h5>
              <Autocomplete
                value={props.formulario.debt}
                nameElement={"debt"}
                formularioBuscado={props.formulario}
                setformulario={props.setFormulario}
                key={update}
                required={true}
                personalHandleChange={handleFormularioStage}
                suggestions={props.listax3}
              ></Autocomplete>
            </div>
            <div className="col-md-4">
              <h5>Moneda</h5>
              <Autocomplete
                value={props.formulario.currency}
                nameElement={"currency"}
                formularioBuscado={props.formulario}
                setformulario={props.setFormulario}
                key={update}
                required={true}
                personalHandleChange={handleFormularioStage}
                suggestions={props.listax2}
              ></Autocomplete>
            </div>

            <div className="col-md-4">
              <h5>Monto</h5>
              <input
                onChange={handleFormularioStage}
                type="number"
                name="amount"
                required
                className="form-control"
              ></input>
            </div>

            <div className="col-md-4">
              <h5>Fecha de titulo</h5>
              <input
                type={"date"}
                onChange={handleFormularioStage}
                name="origindate"
                required
                className="form-control"
              ></input>
            </div>

            <div className="col-md-4">
              <h5>Fecha vencimiento</h5>
              <input
                type={"date"}
                onChange={handleFormularioStage}
                name="duedate"
                required
                className="form-control"
              ></input>
            </div>

            <div className="col-md-4">
              <h5>Comentario</h5>
              <input
                onChange={handleFormularioStage}
                name="comment"
                required
                className="form-control"
              ></input>
            </div>

            <div className="col-md-4">
              <h5>Comprobante</h5>
              <input
                onChange={handleFormularioStage}
                name="client_payment_id"
                required
                className="form-control"
              ></input>
            </div>

            <div className="col-md-4">
              <br />
              <button
                type="button"
                onClick={(e) => {
                  crear(e);
                }}
                value="Submit"
                style={{ margin: "14px 0px" }}
                id="btnBuscar"
                className="form-control button brEdit btn-primary"
              >
                Agregar
              </button>
            </div>
          </form>
        </Modal>
      </>
    );
  }
  if (modulo === "Tribunales") {
    return (
      <>
        <Modal
          isOpen={props.modalIsOpen === "Tribunales" ? true : false}
          contentLabel="Example Modal"
          ariaHideApp={false}
          style={customStyles}
          onRequestClose={closeModal}
        >
          <button
            style={{ position: "absolute", right: "20px", top: "14px" }}
            className=" button  btn-primary"
            onClick={closeModal}
          >
            X
          </button>
          <h4>Agregar Tribunal</h4>
          <form id={modulo}>
            <div className="col-md-4">
              <h5>Tribunal</h5>
              <Autocomplete
                value={props.formulario.court}
                nameElement={"court"}
                formularioBuscado={props.formulario}
                setformulario={props.setFormulario}
                key={update}
                required={true}
                personalHandleChange={handleFormularioStage}
                suggestions={props.listax2}
              ></Autocomplete>
            </div>

            <div className="col-md-4">
              <h5>Tipo Tribunal</h5>
              <Autocomplete
                value={props.formulario.role}
                nameElement={"role"}
                formularioBuscado={props.formulario}
                setformulario={props.setFormulario}
                key={update}
                required={true}
                personalHandleChange={handleFormularioStage}
                suggestions={props.listax}
              ></Autocomplete>
            </div>

            <div className="col-md-4">
              <h5>Rol</h5>
              <input
                onChange={handleFormularioStage}
                value={props.formulario.legalprocessid}
                name="legalprocessid"
                required
                className="form-control"
              ></input>
            </div>

            <div className="col-md-4">
              <br />
              <button
                type="button"
                onClick={(e) => {
                  crear(e);
                }}
                value="Submit"
                style={{ margin: "14px 0px" }}
                id="btnBuscar"
                className="form-control button brEdit btn-primary"
              >
                Agregar
              </button>
            </div>
          </form>
        </Modal>
      </>
    );
  }
  if (modulo === "Deudores") {
    return (
      <>
        <Modal
          isOpen={props.modalIsOpen === "Deudores" ? true : false}
          contentLabel="Example Modal"
          ariaHideApp={false}
          style={customStyles}
          onRequestClose={closeModal}
        >
          <button
            style={{ position: "absolute", right: "20px", top: "14px" }}
            className=" button  btn-primary"
            onClick={closeModal}
          >
            X
          </button>
          <h4>Agregar Tribunal</h4>
          <form id={modulo}>
            <div className="col-md-4">
              <h5>Concepto de deuda</h5>
              <Autocomplete
                value={props.formulario.concept}
                nameElement={"concept"}
                formularioBuscado={props.formulario}
                setformulario={props.setFormulario}
                key={update}
                required={true}
                personalHandleChange={handleFormularioStage}
                suggestions={props.listax}
              ></Autocomplete>
            </div>

            <div className="col-md-4">
              <h5>Acreedor</h5>
              <Autocomplete
                value={props.formulario.creditor}
                nameElement={"creditor"}
                formularioBuscado={props.formulario}
                setformulario={props.setFormulario}
                key={update}
                required={true}
                personalHandleChange={handleFormularioStage}
                suggestions={props.listax2}
              ></Autocomplete>
            </div>

            <div className="col-md-4">
              <h5>Deudor</h5>
              <Autocomplete
                value={props.formulario.debtor}
                nameElement={"debtor"}
                formularioBuscado={props.formulario}
                setformulario={props.setFormulario}
                key={update}
                required={true}
                personalHandleChange={handleFormularioStage}
                suggestions={props.listax3}
              ></Autocomplete>
            </div>

            <div className="col-md-4">
              <h5>Moneda</h5>
              <Autocomplete
                value={props.formulario.currency_id}
                nameElement={"currency_id"}
                formularioBuscado={props.formulario}
                setformulario={props.setFormulario}
                key={update}
                required={true}
                personalHandleChange={handleFormularioStage}
                suggestions={props.listax4}
              ></Autocomplete>
            </div>

            <div className="col-md-4">
              <h5>Descripcion</h5>
              <input
                onChange={handleFormularioStage}
                value={props.formulario.description}
                name="description"
                required
                className="form-control"
              ></input>
            </div>
            <div className="col-md-4">
              <h5>Monto</h5>
              <input
                onChange={handleFormularioStage}
                type="number"
                value={props.formulario.amount}
                name="amount"
                required
                className="form-control"
              ></input>
            </div>
            <div className="col-md-4">
              <h5>Fecha</h5>
              <input
                onChange={handleFormularioStage}
                type="date"
                value={props.formulario.date}
                name="date"
                required
                className="form-control"
              ></input>
            </div>

            <div className="col-md-4">
              <br />
              <button
                type="button"
                onClick={(e) => {
                  crear(e);
                }}
                value="Submit"
                style={{ margin: "14px 0px" }}
                id="btnBuscar"
                className="form-control button brEdit btn-primary"
              >
                Agregar
              </button>
            </div>
          </form>
        </Modal>
      </>
    );
  }
  if (modulo === "Categorias") {
    return (
      <>
        <Modal
          isOpen={props.modalIsOpen === "Categorias" ? true : false}
          contentLabel="Example Modal"
          ariaHideApp={false}
          style={customStyles}
          onRequestClose={closeModal}
        >
          <button
            style={{ position: "absolute", right: "20px", top: "14px" }}
            className=" button  btn-primary"
            onClick={closeModal}
          >
            X
          </button>
          <h4>Agregar Categoria</h4>
          <form id={modulo}>
            <div className="col-md-4">
              <h5>Categoria</h5>
              <Autocomplete
                value={props.formulario.category_id}
                nameElement={"category_id"}
                formularioBuscado={props.formulario}
                setformulario={props.setFormulario}
                key={update}
                required={true}
                personalHandleChange={handleFormularioStage}
                suggestions={props.listax}
              ></Autocomplete>
            </div>

            <div className="col-md-4">
              <br />
              <button
                type="button"
                onClick={(e) => {
                  crear(e);
                }}
                value="Submit"
                style={{ margin: "14px 0px" }}
                id="btnBuscar"
                className="form-control button brEdit btn-primary"
              >
                Agregar
              </button>
            </div>
          </form>
        </Modal>
      </>
    );
  } else {
    return <></>;
  }
};
export default FormularioModulos;
